import { render, staticRenderFns } from "./SwingCard.vue?vue&type=template&id=14504bdb"
import script from "./SwingCard.vue?vue&type=script&lang=js"
export * from "./SwingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports